export const resources = {
  UserAlreadyExistsErrorPageHeader: '',
  UserAlreadyExistsErrorPageText: '',
  UserAlreadyExistsErrorPageNote: '',
  UserAlreadyExistsErrorPageTraceId: '',
  UserAlreadyExistsErrorPageBackToPortalLink: ''
};
